import { PRODUCTION_CONTROL_ROWS } from "../controleConstants";
import { CHARTER_THEME } from "../controleTheme";
import { productionControlBodyCellStyle, productionControlHeaderCellStyle } from "../styles/reportStyles";

export function ProductionControlReport({ value, onChange }) {
    const { inputStyle } = CHARTER_THEME;
    const data = value || {};

    const updateField = (key, nextValue) => {
        onChange({ ...data, [key]: nextValue });
    };

    const updateRow = (key, patch) => {
        onChange({
            ...data,
            rows: {
                ...(data.rows || {}),
                [key]: {
                    ...((data.rows || {})[key] || {}),
                    ...patch,
                },
            },
        });
    };

    return (
        <div style={{
            display: "grid",
            gap: "18px",
            padding: "18px",
            background: "white",
            border: "1px solid #cbd5e1",
            borderRadius: "8px",
            boxShadow: "0 1px 3px rgba(15, 23, 42, 0.06)",
        }}>
            <div style={{ textAlign: "center", color: "#0f172a", fontWeight: 950, lineHeight: 1.25 }}>
                <div style={{ fontSize: "24px" }}>Contrôle en Cours de Production du ROBOT SACHET</div>
                <div style={{ fontSize: "22px", marginTop: "4px" }}>DOSE 405 cassettes</div>
            </div>

            <div style={{ overflowX: "auto", border: "1px solid #cbd5e1", borderRadius: "8px", background: "white" }}>
                <table style={{ width: "100%", minWidth: "1040px", borderCollapse: "collapse" }}>
                    <thead>
                        <tr style={{ background: "#e2e8f0" }}>
                            <th style={{ ...productionControlHeaderCellStyle, width: "130px" }}>Date et heure</th>
                            <th style={{ ...productionControlHeaderCellStyle, width: "140px" }}>Opérateur</th>
                            <th style={productionControlHeaderCellStyle}>Équipement</th>
                            <th style={productionControlHeaderCellStyle}>Paramètres de Contrôle</th>
                            <th style={{ ...productionControlHeaderCellStyle, width: "170px" }}>Valeurs Mesurées</th>
                            <th style={{ ...productionControlHeaderCellStyle, width: "140px" }}>Conformité (O/N)</th>
                            <th style={{ ...productionControlHeaderCellStyle, width: "260px" }}>Observations VISA</th>
                        </tr>
                    </thead>
                    <tbody>
                        {PRODUCTION_CONTROL_ROWS.map(([key, label, parameter], index) => {
                            const row = (data.rows || {})[key] || {};
                            return (
                                <tr key={key}>
                                    {index === 0 && (
                                        <>
                                            <td rowSpan={PRODUCTION_CONTROL_ROWS.length} style={productionControlBodyCellStyle}>
                                                <input
                                                    type="datetime-local"
                                                    style={{ ...inputStyle, width: "100%" }}
                                                    value={data.dateHeure || ""}
                                                    onChange={event => updateField("dateHeure", event.target.value)}
                                                />
                                            </td>
                                            <td rowSpan={PRODUCTION_CONTROL_ROWS.length} style={productionControlBodyCellStyle}>
                                                <input
                                                    style={{ ...inputStyle, width: "100%" }}
                                                    value={data.operateur || ""}
                                                    onChange={event => updateField("operateur", event.target.value)}
                                                    placeholder="Opérateur"
                                                />
                                            </td>
                                        </>
                                    )}
                                    <td style={{ ...productionControlBodyCellStyle, fontWeight: index === 0 ? 900 : 800, fontSize: index === 0 ? "18px" : "14px" }}>
                                        {label}
                                    </td>
                                    <td style={productionControlBodyCellStyle}>
                                        <textarea
                                            style={{ ...inputStyle, width: "100%", minHeight: "50px", resize: "vertical", lineHeight: 1.35 }}
                                            value={row.parametre ?? parameter}
                                            onChange={event => updateRow(key, { parametre: event.target.value })}
                                        />
                                    </td>
                                    <td style={productionControlBodyCellStyle}>
                                        <input
                                            style={{ ...inputStyle, width: "100%" }}
                                            value={row.valeurMesuree || ""}
                                            onChange={event => updateRow(key, { valeurMesuree: event.target.value })}
                                            placeholder="Valeur"
                                        />
                                    </td>
                                    <td style={productionControlBodyCellStyle}>
                                        <select
                                            style={{ ...inputStyle, width: "100%" }}
                                            value={row.conformite || ""}
                                            onChange={event => updateRow(key, { conformite: event.target.value })}
                                        >
                                            <option value="">—</option>
                                            <option value="O">O</option>
                                            <option value="N">N</option>
                                        </select>
                                    </td>
                                    <td style={productionControlBodyCellStyle}>
                                        <textarea
                                            style={{ ...inputStyle, width: "100%", minHeight: "50px", resize: "vertical", lineHeight: 1.35 }}
                                            value={row.observations || ""}
                                            onChange={event => updateRow(key, { observations: event.target.value })}
                                            placeholder="Observations / VISA"
                                        />
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>

            <div style={{
                display: "grid",
                gap: "14px",
                padding: "14px",
                border: "1px solid #cbd5e1",
                borderRadius: "8px",
                background: "#f8fafc",
            }}>
                <label style={{ display: "grid", gap: "7px" }}>
                    <span style={{ color: "#0f172a", fontSize: "14px", fontWeight: 900 }}>Commentaire/autre problème</span>
                    <textarea
                        style={{ ...inputStyle, width: "100%", minHeight: "96px", resize: "vertical", lineHeight: 1.45 }}
                        value={data.commentaireAutre || ""}
                        onChange={event => updateField("commentaireAutre", event.target.value)}
                        placeholder="Commentaire"
                    />
                </label>
                <label style={{ display: "grid", gridTemplateColumns: "minmax(190px, auto) minmax(220px, 1fr)", gap: "10px", alignItems: "center", maxWidth: "620px" }}>
                    <span style={{ color: "#334155", fontSize: "13px", fontWeight: 900 }}>Signature Pharmacien:</span>
                    <input
                        style={{ ...inputStyle, width: "100%" }}
                        value={data.signaturePharmacien || ""}
                        onChange={event => updateField("signaturePharmacien", event.target.value)}
                        placeholder="Signature"
                    />
                </label>
            </div>
        </div>
    );
}
